// 点击导航语言按钮切换多语言
export const setLang = (langType) => {
    console.log('=== setLanguage__setLang >>>', langType);
};